// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import SiteFillSvg from '@rsuite/icon-font/lib/layout/SiteFill';
var SiteFill = createSvgIcon({
  as: SiteFillSvg,
  ariaLabel: 'site fill',
  category: 'layout',
  displayName: 'SiteFill'
});
export default SiteFill;